import React, { useState } from "react";
import { http } from "../helper";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import CommonAlert from "../common/Commonalert";
import { BaseUrl } from "../common/config";
import Loader from "../common/loader";
import { useTranslation } from "react-i18next";

const Forgotpassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loginStatus, setLoginStatus] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);

  const validateEmail = (email) => {
    const trimmedEmail = email.trim();
    const emailRegex =
      /^[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/g;
    return emailRegex.test(trimmedEmail);
  };

  const emailChange = (event) => {
    setEmail(event.target.value);
    setLoginStatus("");
    setLoginMessage("");
    setAlertPopup(false);
  };

  const loginOnSubmit = (event) => {
    event.preventDefault();
    setAlertPopup(false);
    const URL = BaseUrl + "admin/forgotpassword";
    if (validateEmail(email)) {
      const payload = {
        emailaddress: email.trim(),
      };
      setIsLoading(true);
      http
        .post(URL, payload)
        .then((response) => {
          if (response.data.success === true) {
            setAlertPopup(true);
            setAlertMessage(
              t("emailed_link_msg")
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status === 400) {
            setAlertPopup(true);
            setAlertMessage(error.response.data.message);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setAlertPopup(false);
          }
        });
    } else {
      setLoginStatus(401);
      setAlertPopup(false);
      setLoginMessage(t("valid_email_errmsg_txt"));
    }
  };

  return (
    <>
      {alertPopup === true && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <div className="login-page">
        <Header />
        {!isLoading && (
          <div className="login">
            <div className="form">
              <div className="login-form">
                <h2>{t("reset_pass_lbl")}</h2>
                <p>
                  {t("reset_email_msgtxt")}
                </p>
                <div className="input-field">
                  <input
                    type="text"
                    id="accountEmail"
                    value={email}
                    placeholder={t("email_address_txt")}
                    required
                    onChange={emailChange}
                  />
                  {loginStatus ? (
                    loginStatus === 401 ? (
                      <div className="error-msg">{loginMessage}</div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
                <button title={t("submit_txt")} type="button" onClick={loginOnSubmit}>
                  {t("submit_txt")}{}
                </button>
              </div>
            </div>
            <div className="back-to-cat">
              <a title={t("back_to_home_txt")} className="back-btn" href="/">
                <i className="fa fa-arrow-left"></i> {t("back_to_home_txt")}
              </a>
            </div>
          </div>
        )}
        {isLoading && <Loader propsClassName="load-lag" />}
        <Footer />
      </div>
    </>
  );
};

export default Forgotpassword;